import React from 'react';
import Table from '../UI/table/Table';
import { AppContext } from 'src/store/ContextStore';
import useDateFormatter from 'src/hooks/useDateFormatter';
import UsersTableStatusCol from '../proband-info/UsersTableStatusCol';
import { GLOBAL_CONSTANTS, TABLE_CONSTANTS } from '../Constants';
import { basePath as customFormBasePath } from 'src/components/custom-form/Constants';
import CustomIconBtn from '../UI/button/CustomIconBtn';
import { originWithBase } from 'src/util/basePath';

function PatientLinks() {
  const fmtDate = useDateFormatter();
  const {
    content: {
      formBuilder: { linksGenerated }
    }
  } = React.useContext(AppContext);

  const createUniqueLink = (token) => {
    return `${originWithBase()}${customFormBasePath}?${
      GLOBAL_CONSTANTS.tokenKey
    }=${token}`;
  };

  const visitLink = (token) => {
    window.open(createUniqueLink(token), '_blank');
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'responseId',
        header: 'Response ID',
        size: 160
      },
      {
        accessorKey: 'user.email',
        header: 'E-mail'
      },
      {
        accessorKey: 'form.title',
        header: 'Form Template'
      },
      {
        accessorKey: 'workflow.workflowName',
        header: 'Workflow'
      },
      {
        id: 'dateGenerated',
        header: 'Date Generated',
        size: 180,
        Cell: ({ row }) => fmtDate(row.original.dateGenerated)
      },
      {
        accessorKey: 'status',
        header: 'Link Status',
        size: 180,
        enableSorting: false,
        Cell: ({ cell }) => <UsersTableStatusCol status={cell.getValue()} />
      },
      {
        id: 'actions',
        header: 'Actions',
        size: 180,
        enableSorting: false,
        Cell: ({ row }) => (
          <CustomIconBtn
            type="view"
            tooltip="view"
            onClick={() => visitLink(row.original.token)}
          />
        )
      }
    ],
    []
  );

  const table = React.useMemo(() => {
    // const columns = [
    //   {
    //     title: 'Response ID',
    //     field: 'responseId',
    //     width: 160
    //   },
    //   { title: 'E-mail', field: 'user.email' },
    //   { title: 'Form Template', field: 'form.title' },
    //   { title: 'Workflow', field: 'workflow.workflowName' },

    //   {
    //     title: 'Date Generated',
    //     render: (rowData) => parseDate(rowData.dateGenerated),
    //     width: 180
    //   },
    //   {
    //     title: 'Link Status',
    //     field: 'status',
    //     width: 180,
    //     sorting: false,
    //     render: ({ status }) => <UsersTableStatusCol status={status} />
    //   },
    //   {
    //     title: 'Actions',
    //     width: 180,
    //     sorting: false,
    //     render: (rowData) => (
    //       <CustomIconBtn
    //         type={'view'}
    //         tooltip={'view'}
    //         onClick={() => visitLink(rowData.token)}
    //       />
    //     )
    //   }
    // ];

    return (
      <Table
        title="Submissions"
        rows={linksGenerated}
        columns={columns}
        pageSize={5}
        pageSizeOptions={[5, 10, 15, 20, 30, 40, 50]}
        dense={true}
        tableKey={TABLE_CONSTANTS.patientLinks}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linksGenerated, fmtDate]);

  return <div>{table}</div>;
}

export default PatientLinks;
